import { io } from 'socket.io-client';

const URL = 'https://infinitygymnastics-app-d76b087a1ffe.herokuapp.com';

export const socket = io(URL);